import React, { useState, useEffect, useContext } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import avatar from "../../assets/images/users/td_logo.jpeg";
import { LoadingContext } from "../../../src/Pages/Utility/spinner/LoadingContext";

const UserProfile = () => {
  const { setIsLoading } = useContext(LoadingContext);
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("home");

  useEffect(() => {
    document.title = "User Profile | Valitan";

    // Retrieve and parse user details from local storage
    const fetchUser = async () => {
      try {
        setIsLoading(true);
        const authUser = localStorage.getItem("authUser");
        if (authUser) {
          const { user } = JSON.parse(authUser);
          setUser(user);
        } else {
          setUser(null); // Handle case where no user data is found
        }
      } catch (error) {
        console.error("Error parsing authUser from localStorage:", error);
        setUser(null); // Handle error or reset user
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [setIsLoading]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Users management" breadcrumbItem="Profile" />
          {user && (
            <Row>
              <Col lg="4">
                <Card>
                  <CardBody>
                    <div>
                      <img
                        src={avatar}
                        alt="User Avatar"
                        className="avatar-lg rounded-circle img-thumbnail mx-auto d-block"
                        style={{ marginBottom: "16px" }}
                      />
                    </div>
                    <hr
                      style={{
                        width: "90%",
                        margin: "20px auto",
                        border: "0",
                        height: "1px",
                        backgroundImage: "linear-gradient(to right, rgba(0,0,0,0), #999da1, rgba(0,0,0,0))",
                      }}
                    />
                    <div className="text-muted">
                      <table className="table table-md">
                        <tbody>
                          <tr>
                            <td>
                              <i className="ri-share-forward-line font-size-16 align-middle text-primary me-2"></i>{" "}
                              First Name:
                            </td>
                            <td>{user.first_name}</td>
                          </tr>
                          <tr>
                            <td>
                              <i className="ri-share-forward-line font-size-16 align-middle text-primary me-2"></i>{" "}
                              Middle Name:
                            </td>
                            <td>{user.middle_name}</td>
                          </tr>
                          <tr>
                            <td>
                              <i className="ri-share-forward-line font-size-16 align-middle text-primary me-2"></i>{" "}
                              Last Name:
                            </td>
                            <td>{user.last_name}</td>
                          </tr>
                          <tr>
                            <td>
                              <i className="ri-share-forward-line font-size-16 align-middle text-primary me-2"></i>{" "}
                              Sex:
                            </td>
                            <td>{user.sex}</td>
                          </tr>
                          <tr>
                            <td colSpan={2} className="text-center text-white bg-primary text-uppercase">
                              {Array.isArray(user.roles) && user.roles.length > 0
                                ? user.roles.map((r) => r.name).join(", ")
                                : "N/A"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="8" className="ms-auto">
                <div className="card">
                  <div className="card-body">
                    <ul className="navtab-bg nav-justified nav nav-pills">
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "home" ? "active" : ""}`}
                          onClick={() => setActiveTab("home")}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="dripicons-home me-1 align-middle"></i> Home
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "profile" ? "active" : ""}`}
                          onClick={() => setActiveTab("profile")}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="dripicons-user me-1 align-middle"></i> Profile
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "messages" ? "active" : ""}`}
                          onClick={() => setActiveTab("messages")}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="dripicons-mail me-1 align-middle"></i> Messages
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "settings" ? "active" : ""}`}
                          onClick={() => setActiveTab("settings")}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="dripicons-gear me-1 align-middle"></i> Settings
                        </button>
                      </li>
                    </ul>

                    <div className="tab-content p-3 text-muted">
                      {activeTab === "home" && (
                        <div>
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum.
                          </p>
                        </div>
                      )}
                      {activeTab === "profile" && (
                        <div>
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum.
                          </p>
                        </div>
                      )}
                      {activeTab === "messages" && (
                        <div>
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum.
                          </p>
                        </div>
                      )}
                      {activeTab === "settings" && (
                        <div>
                          <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                            culpa qui officia deserunt mollit anim id est laborum.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;